export const MATRIX_LENGTH = 8;
